(() => {
  document.addEventListener('click', (event) => {
    const header = event.target.closest('.specs-accordion-header');
    if (!header) return;

    const panelId = header.getAttribute('data-target');
    const panel = panelId ? document.getElementById(panelId) : header.nextElementSibling;
    if (!panel) return;

    const item = header.closest('.specs-accordion-item');
    panel.classList.toggle('open');
    item?.classList.toggle('active');
  });
})();
